import { StatsContexterServiceInterface } from './service.interface';
import { StatsContexterFactory } from '../../module/stats/contexter.factory';

const statsContexterService = StatsContexterFactory();

export function StatsContexterService(): StatsContexterServiceInterface {
  return statsContexterService;
}
